import { getServiceName } from '@repo/utils';

import BubblechatTermsOfService from './bubblechat'; // bubblechat 전용
import TingleTermsOfService from './tingle'; // tingle 전용

const TermsOfService = () => {
  const serviceName = getServiceName();
  if (serviceName === 'tingle') return <TingleTermsOfService />;
  return <BubblechatTermsOfService />;
};

export default TermsOfService;
